import Mutations from '../../odata/mutations';

export default { ...new Mutations('feedbackComment'), ...new Mutations('feedbackComments') };
